import { useRouter } from "@tanstack/react-router"
import { useEffect } from "react"


export const ScrollToTop = () => {
  const router = useRouter()
  const location = router.state.location

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.state])

  return null
}